export enum EnumFeaturesActionsDestinations {
    Geofences = "Geofences",
    Tool = "Tool",
    Ninguno = ""
}